/**
 * `Field` — form-field wrapper (label + optional hint + required marker).
 * Same shape as the dashboard's atom.
 */

import type { ReactNode } from 'react';

import { useC } from '../../lib/theme.js';

const sansFont = "'Geist', sans-serif";

export interface FieldProps {
  label: ReactNode;
  hint?: ReactNode;
  required?: boolean;
  children: ReactNode;
}

export function Field({ label, hint, required, children }: FieldProps): JSX.Element {
  const C = useC();
  return (
    <div>
      <label
        style={{
          fontFamily: sansFont,
          fontSize: 12,
          color: C.text,
          fontWeight: 500,
          display: 'block',
          marginBottom: 6,
        }}
      >
        {label}
        {required ? <span style={{ color: C.coralFg }}> *</span> : null}
      </label>
      {children}
      {hint ? (
        <div
          style={{
            fontFamily: sansFont,
            fontSize: 11,
            color: C.muted,
            marginTop: 4,
            lineHeight: 1.5,
          }}
        >
          {hint}
        </div>
      ) : null}
    </div>
  );
}
